import React from "react";
import "../Styles/usage.css";

const BadgePage = () => {
  return (
    <div className="badge-container">

      {/* ===== SECTION 1 ===== */}
      <div className="section1">
        <div className="left">
          <img src="/assets/Ribon_2.png" alt="ribbon" />
        </div>

        <div className="right">
          <h1>
            Well done on earning the <br />
            Outstanding Workplaces Certification!
          </h1>

          <p>
            You now have the right to display your certification badge, royalty-free, for the next 12 months. This page will help you understand the best and correct ways to use your badge and highlight your achievement.
          </p>
        </div>
      </div>

      {/* ===== SECTION 2 ===== */}
      <div className="section2">
       <h2>What Your Badge Represents</h2>

<div className="usage-grid">
  
  <div className="card move-left">
    <img src="/assets/br_1.png" alt="icon" />
    
    <h3>Recognized & Trusted Certification</h3>
    <p>
      The Outstanding Workplaces Certification badge is a recognized and trusted symbol of excellence. Earned entirely through employee feedback, it reflects a genuine commitment to building a positive, supportive, and fulfilling work environment one your people truly believe in.
    </p>
  </div>

          <div className="card card-left">
  <img src="/assets/br_2.png" alt="icon" />
  
  <h3>Built On Employee Feedback</h3>
  <p>
    Unlike traditional workplace awards, this certification is driven solely by employee voices. Your badge represents real experiences, real trust, and a culture that puts people first because recognition means more when it comes from within.
  </p>
</div>

<div className="card card-right">
  <img src="/assets/br_3.png" alt="icon" />
  
  <h3>Strengthen Your Recruitment Brand</h3>
  <p>
    Today’s talent looks beyond compensation. With the Outstanding Workplaces Certification badge, you demonstrate a strong, people-centric culture helping you stand out, build trust, and attract candidates who share your values.
  </p>
</div>
        </div>
      </div>

      {/* ===== SECTION 3 ===== */}
      <div className="section3">
        <h2>Where to Use It</h2>

        <div className="icon-row">
          <div className="icon-box">
            <img src="/assets/useit_1.png" alt="" />
            <p>Employer Branding Materials</p>
          </div>
          <div className="icon-box">
            <img src="/assets/useit_2.png" alt="" />
            <p>Pitch Decks & Corporate Presentations</p>
          </div>
          <div className="icon-box">
            <img src="/assets/useit_3.png" alt="" />
            <p>Job Postings & Hiring Campaigns</p>
          </div>
          <div className="icon-box">
            <img src="/assets/useit_4.png" alt="" />
            <p>Email Signatures</p>
          </div>
        </div>

        <div className="icon-row">
          <div className="icon-box">
            <img src="/assets/useit_5.png" alt="" />
            <p>Website & Career Pages</p>
          </div>
          <div className="icon-box">
            <img src="/assets/useit_6.png" alt="" />
            <p>Social media & LinkedIn creatives</p>
          </div>
          <div className="icon-box">
            <img src="/assets/useit_7.png" alt="" />
            <p>Office Posters & Digital Displays</p>
          </div>
          <div className="icon-box">
            <img src="/assets/useit_8.png" alt="" />
            <p>Business Cards</p>
          </div>
        </div>
      </div>

    </div>
  );
};

export default BadgePage;